import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { useSamplingQueries } from '../data-access/queries/sampling';

export const useOrderPage = () => {
  const { id } = useParams({
    from: '/_app/_admin/orders_/$id',
  });
  const samplingQueries = useSamplingQueries();
  const order = useSuspenseQuery(samplingQueries.orders.detail(Number(id)));
  return { order };
};
